module.exports = __webpack_public_path__ + "img/IIAFvsSPQR.905cd1f2.png";